import React, { useEffect, useState } from 'react';

import Column from '../../common/utility/column';
import RaceTimeTable from './components/raceTimeTable';
import { RaceTime } from '../../../types/apiResponses';

import './myTimes.css';

export default function MyTimes() {
	const [blindKaizoTimes, setBlindKaizoTimes] = useState<RaceTime[]>([]);

	useEffect(() => {
		fetch('/api/user/raceTimes')
			.then((res) => res.json())
			.then((res) => {
				setBlindKaizoTimes(res.raceTimes ?? []);
			})
			.catch(console.error);
	}, []);

	return (
		<Column>
			<h2>Times</h2>
			<RaceTimeTable title="Blind Kaizo Races" raceTimes={blindKaizoTimes} />
		</Column>
	);
}
